<template>
    <div class="table-cover">
        <header class="table-cover__header">
            <template v-if="type == 'pipeline'">
                <p class="mb-0">Add / Manage Funnel Stages</p>
                <button @click="addField" class="button">+ Add Stages</button>
            </template>
            <template v-else-if="type == 'tracker_review'">
                <p class="mb-0">Add fields for team members to use when reviewing startups for a tracker.</p>
                <button @click="addField" class="button">+ Add Field</button>
            </template>
            <template v-else-if="type == 'tracker_question'">
                <p class="mb-0">Add questions for startups to answer when applying to a tracker.</p>
                <button @click="addField" class="button">+ Add Field</button>
            </template>
            <template v-else-if="type == 'tracker_diligence'">
                <p class="mb-0">Add/ Manage fields for startups in the submission table in your trackers.</p>
                <button @click="addField" class="button">+ Add Field</button>
            </template>
            <template v-else>
                <p class="mb-0">Add fields for team members to fill when submitting trackers</p>
                <button @click="addField" class="button">+ Add Field</button>
            </template>
        </header>

        <Grid v-if="fields.length"
              :columns="columns"
              :data="fields"
              :page-length="pageLength"
              :total-rows-count="totalRowsCount"
              :sort="sort"
              :currentPage="currentPage"
              v-on:changePage="changePage"
              v-on:changeSort="changeSort"
              v-on:action="action"
        >
        </Grid>

        <EditField
            ref="editField"
            :sectionId="0"
            :type="type"
            :fieldType="fieldType"
            :index="'fields-' + type"
            v-on:fieldSaved="getList"
        >
        </EditField>
    </div>
</template>

<script>
import grid from "@/mixins/grid";
import Grid from "@/components/Grid";
import EditField from "@/components/customFields/EditField";
import customFields from "@/services/custom-fields.service";

export default {
    props: {
        type: String,
        fieldType: {
            type: String,
            default: null
        }
    },

    mixins: [grid],

    components: {
        Grid,
        EditField,
    },

    data() {
        return {
            fields: [],

            columns: [
                {
                    name: 'name',
                    label: 'Name',
                },
                {
                    name: 'type',
                    label: 'Type',
                },
                {
                    name: 'permissions',
                    label: 'Permissions',
                    component: 'Permissions',
                },
                {
                    name: 'actions',
                    label: 'Actions',
                    component: 'Actions',
                }
            ]
        }
    },

    mounted() {
        if (this.fieldType) {
            this.columns.splice(1,1)
        }

        this.getList()
    },

    methods: {
        getList() {
            let currentPage = this.currentPage
            let pageLength = this.pageLength

            customFields.getIndexTypeFields(this.type, {currentPage, pageLength}).then(response => {
                this.fields = response.data.data
                this.totalRowsCount = parseInt(response.data.total_count)
                this.currentPage = response.data.current_page
            })
        },

        addField() {
            this.$refs.editField.open(0)
        },

        action(params) {
            if (params.action == 'edit') {
                this.$refs.editField.open(params.rowId)
            }

            if (params.action == 'delete') {
                customFields.checkRelations(params.rowId).then(response => {
                    let string = "Delete Field?";

                    for (let type in response.data) {
                        if (type == 'trackers') {
                            string += "\nRemoving this field will also remove it from related templates and trackers: \n" + response.data[type].join(",\n")
                        }
                    }

                    if (confirm(string)) {
                        customFields.delete(params.rowId).then(() => {
                            this.getList()
                        })
                    }
                })
            }
        },
    }
}
</script>

<style scoped>

</style>